import {decimal} from "@/mixins/NumberFormattingFilters";

const gradeConversionTable = {
	values: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
	keys: ['O', 'D', 'E', 'F', 'G', 'H', 'K', 'L', 'M', 'N']
};

export function encodeGrade(value) {
	const gradeParts = decimal(value, 'en-US').toString().split('.');

	if (gradeParts.length === 2) {
		gradeParts[1] = gradeParts[1].padEnd(2, '0');
	} else {
		gradeParts.push('00');
	}

	return `${gradeParts[0]}.${gradeParts[1]}`.toString().replace(/\d/g, (gradeNum) => {
		return gradeConversionTable.keys[gradeNum];
	});
}

/**
 * Call filter in template as {{ variableToFormat | grade(gradeVal) }}
 */
export default {
	filters: {
		encodeGrade: encodeGrade
	}
}